/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "#/lib/social-signal-api-client.ts"
import type {
  RequestConfig,
  ResponseErrorConfig,
} from "#/lib/social-signal-api-client.ts"
import type {
  UpdateProfileMutationRequest,
  UpdateProfileMutationResponse,
  UpdateProfile401,
} from "../types/UpdateProfile.ts"
import {
  updateProfileMutationResponseSchema,
  updateProfileMutationRequestSchema,
} from "../zod/updateProfileSchema.ts"

function getUpdateProfileUrl() {
  const res = { method: "PUT", url: `/me/profile` as const }
  return res
}

/**
 * @summary Update your profile
 * {@link /me/profile}
 */
export async function updateProfile(
  data: UpdateProfileMutationRequest,
  config: Partial<RequestConfig<UpdateProfileMutationRequest>> & {
    client?: typeof fetch
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = updateProfileMutationRequestSchema.parse(data)

  const res = await request<
    UpdateProfileMutationResponse,
    ResponseErrorConfig<UpdateProfile401>,
    UpdateProfileMutationRequest
  >({
    method: "PUT",
    url: getUpdateProfileUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return updateProfileMutationResponseSchema.parse(res.data)
}
